<template>
    <v-container>
      <v-row>
        <v-col md="12" class="pa-6 text-left text-justify">
          <div class="my-6">
                    <p class="text-h4 text--primary">
                        <TextHeading :level=3>Zarządzanie / Rozliczanie projektów</TextHeading>
                    </p>
                    <div class="text-body-1 text--primary">
                      Naszym Klientom, w odróżnieniu od Konkurencji, oferujemy kompleksową obsługę, tzn. jeżeli dany projekt został przez nas napisany to również prowadzimy jego rozliczenie aż do zakończenia i zaakceptowania przez Instytucję Zarządzającą lub Pośredniczącą – wykaz niektórych prowadzonych przez Nas projektów możecie Państwo znaleźć <router-link class="nav-link" to="/our_projects/prepare_funds">tu</router-link>
                    </div>
                    <br />
                    <div class="text-body-1 text--primary">
                      Jeżeli zostaliście Państwo z przyznanym dofinansowaniem i szukacie solidnego oraz doświadczonego Partnera do prowadzenia Projektu, to zdecydowanie trafiliście w odpowiednie miejsce.
                    </div>
                    <v-list dense disabled>
                      <v-list-item
                        v-for="(item, i) in goals"
                        :key="i"
                      >
                        <v-list-item-icon>
                          <v-icon>{{ item.icon }}</v-icon>
                        </v-list-item-icon>

                        <v-list-item-title class="text-body-1 text--primary text-wrap font-weight-regular">{{ item.text }}</v-list-item-title>
                      </v-list-item>
                    </v-list>
                    <div class="text-body-1 text--primary">
                      Jeżeli chcecie Państwo poznać naszą ofertę, zachęcamy do kontaktu:
                    </div>
                    <management-form />
          </div>
        </v-col>
      </v-row>
    </v-container>
  </template>
  <script>
  import TextHeading from "@/modules/TextHeading";
  import ManagementForm from "@/modules/forms/ManagementForm";
  export default {
  
    components: {TextHeading, ManagementForm},

    data: () => ({
      goals: [
        {
          text: 'Przygotowywanie postępowań w ramach projektu;',
          icon: "mdi-circle-medium"
        },
        {
          text: 'Przygotowanie wzorów dokumentacji, projektowej niezbędnej do prawidłowego rozliczania projektu,',
          icon: "mdi-circle-medium"
        },
        {
          text: 'Obsługę systemu SL 2014,',
          icon: "mdi-circle-medium"
        },
        {
          text: 'Przygotowywanie wniosków o płatność i sprawozdań;',
          icon: "mdi-circle-medium"
        },
        {
          text: 'Rozliczanie projektu;',
          icon: "mdi-circle-medium"
        },
        {
          text: 'Udział w kontrolach na zakończenie Projektu;',
          icon: "mdi-circle-medium"
        },
      ],
    })
  }
  </script>